(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[524],{

/***/ 2231:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries/[id]/collections/[collection]",
      function () {
        return __webpack_require__(4929);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ GalleryHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _material_ui_icons_Instagram__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4363);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4051);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1555);
/* harmony import */ var _services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3992);
/* harmony import */ var _services_utils_slugify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3384);
/* harmony import */ var _Layout_HeadingTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8434);
/* harmony import */ var _GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6656);
/* harmony import */ var _GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);










const GalleryHeader = (param)=>{
    let { galleryDetails , onClickContact  } = param;
    const initials = galleryDetails.name.split(/\s/).reduce((response, word)=>response += word.slice(0, 1), "").toUpperCase().substring(0, 3);
    const makeContactData = ()=>{
        const website = galleryDetails.website && galleryDetails.website.replace("https://", "").replace("http://", "");
        const contactItems = [
            galleryDetails.phone,
            website && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                className: "text-decoration-underline",
                href: "http://".concat(website),
                target: "_blank",
                children: website
            }),
            galleryDetails.instagram && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "https://www.instagram.com/".concat(galleryDetails.instagram.replace("/", "").trim()),
                    target: "_blank",
                    className: (_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-instagram"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Instagram__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            style: {
                                width: 18,
                                fontSize: "18px"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: galleryDetails.instagram
                        })
                    ]
                })
            }),
            onClickContact ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                onClick: onClickContact,
                className: "text-decoration-underline font-secondary contactBlack cursor-pointer",
                children: "Get in touch"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/galleries/[id]/contact",
                as: "/galleries/".concat(galleryDetails.id, "-").concat((0,_services_utils_slugify__WEBPACK_IMPORTED_MODULE_7__/* .slugify */ .l)(galleryDetails.name), "/contact"),
                className: "text-decoration-underline font-secondary contactBlack",
                children: "Get in touch"
            })
        ].filter((i)=>i);
        const contactItemsDesktop = contactItems.reduce((arr, b)=>[
                ...arr,
                b,
                " \xb7 "
            ], []).slice(0, -1);
        const contactItemsMobile = contactItems.map((value, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-1",
                children: value
            }, "contact-item-".concat(index)));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-links"]), "color-gray-light"),
            children: [
                galleryDetails.address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        galleryDetails.address,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactItemsDesktop), "contactBlack", "fw-700"),
                    children: contactItemsDesktop
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactItemsMobile), "contactBlack", "fw-700"),
                    children: contactItemsMobile
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-header"])),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-header-thumbnail"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/galleries/".concat(galleryDetails.domain),
                    children: galleryDetails.thumbnail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-logo"]),
                        style: {
                            backgroundImage: "url(".concat((0,_services_utils_imageResizer__WEBPACK_IMPORTED_MODULE_10__/* .imageResizer */ .J)(galleryDetails.thumbnail, 220, 220), ")")
                        }
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-initials"]), "mb-4"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-inicials"]),
                            children: initials
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-header-info"])),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Layout_HeadingTitle__WEBPACK_IMPORTED_MODULE_3__/* .HeadingTitle */ .E, {
                    title: galleryDetails.name,
                    href: "/galleries/".concat(galleryDetails.domain),
                    to: "/galleries/".concat(galleryDetails.domain),
                    children: [
                        galleryDetails.bio && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_GalleryHeader_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["gallery-header-bio"]),
                            children: [
                                galleryDetails.bio,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                            ]
                        }),
                        makeContactData()
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 8434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ HeadingTitle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);



const HeadingTitle = (param)=>{
    let { title , children , href , to  } = param;
    const Title = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                href && to && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "mb-1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: href,
                        as: to,
                        className: "text-black fw-600 fs-32px fs-mobile-28px lh-36px d-block",
                        style: {
                            marginLeft: "-3px"
                        },
                        children: title
                    })
                }),
                !href && !to && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-black mb-1 fw-600",
                    style: {
                        marginLeft: "-3px"
                    },
                    children: title
                }),
                children && children !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "color-black font-secondary fs-15px fs-mobile-14px pb-lg-1 mb-0",
                    children: children
                })
            ]
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {});
};


/***/ }),

/***/ 6627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./features/components/Layout/LoadingLabel/LoadingLabel.module.scss
var LoadingLabel_module = __webpack_require__(7129);
var LoadingLabel_module_default = /*#__PURE__*/__webpack_require__.n(LoadingLabel_module);
;// CONCATENATED MODULE: ./features/components/Layout/LoadingLabel/index.js




const LoadingLabel = (param)=>/*#__PURE__*/ {
    let { height , width , maxWidth , className  } = param;
    return (0,jsx_runtime.jsx)("span", {
        className: classnames_default()((LoadingLabel_module_default())["loading-label"], className),
        style: {
            height,
            width,
            maxWidth
        }
    });
};
LoadingLabel.defaultProps = {
    height: 16,
    width: "100%",
    className: ""
};

;// CONCATENATED MODULE: ./features/components/Layout/Image/index.js



const Image = (param)=>{
    let { src , labelHeight ="250px" , labelWidth ="100%" , ...rest } = param;
    const [loaded, setLoaded] = (0,react.useState)(false);
    const img = (0,react.useRef)();
    (0,react.useEffect)(()=>{
        if (img.current.complete) {
            setLoaded(true);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loaded && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingLabel, {
                className: rest.className,
                height: labelHeight,
                width: labelWidth
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                ref: img,
                alt: rest.alt || "",
                style: {
                    display: loaded ? "block" : "none"
                },
                ...rest,
                onLoad: ()=>setLoaded(true)
            })
        ]
    });
};
766;


/***/ }),

/***/ 4929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _collection_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/error.js
var error = __webpack_require__(2918);
var error_default = /*#__PURE__*/__webpack_require__.n(error);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./services/utils/linksBuilder.js
var linksBuilder = __webpack_require__(3372);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./services/utils/isEmptyObject.js
var isEmptyObject = __webpack_require__(9657);
// EXTERNAL MODULE: ./services/utils/sorts.js
var sorts = __webpack_require__(7599);
// EXTERNAL MODULE: ./services/WindowService/index.js + 1 modules
var WindowService = __webpack_require__(2480);
// EXTERNAL MODULE: ./services/utils/getQueryStringValue.js
var getQueryStringValue = __webpack_require__(4694);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/utils/buildParams.js
// TODO: This is the same as the buildParams in ArtworksPage, generalize.

const buildParams = (search, sort)=>{
    const { colors , sizes , type , orientations , medium , material , minHeight , maxHeight , minWidth , maxWidth  } = search;
    const queryStringValue = (0,getQueryStringValue/* getQueryStringValue */.j)("search");
    let params = {};
    if (sizes.length > 0) {
        params["size"] = sizes;
    }
    if ((type === null || type === void 0 ? void 0 : type.length) > 0) {
        params["type"] = type;
    }
    if (orientations.length > 0) {
        params["orientation"] = orientations;
    }
    if (medium.length > 0) {
        params["medium"] = medium;
    }
    if (material.length > 0) {
        params["material"] = material;
    }
    if (colors.length > 0) {
        params["colorsfilter"] = colors;
    }
    if (minHeight && minHeight > 0) {
        params["minh"] = minHeight;
    }
    if (maxHeight && maxHeight > 0) {
        params["maxh"] = maxHeight;
    }
    if (minWidth && minWidth > 0) {
        params["minw"] = minWidth;
    }
    if (maxWidth && maxWidth > 0) {
        params["maxw"] = maxWidth;
    }
    if (sort) {
        params["order"] = sort;
    }
    if (!!queryStringValue) {
        params["search"] = queryStringValue;
    }
    return params;
};

// EXTERNAL MODULE: ./services/nodeApiService.js + 1 modules
var nodeApiService = __webpack_require__(9885);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/utils/callArtworksApi.js

const callArtworksApi = (params, gallery, collection)=>nodeApiService/* default.galleryArtworksByCollection */.Z.galleryArtworksByCollection(gallery.id, collection, params);

// EXTERNAL MODULE: ./features/actions/useInfinitePagination.js
var useInfinitePagination = __webpack_require__(6578);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/utils/mapQueryParams.js
// TODO: This is ALMOST the same as the mapQueryParams in artworks page, generalize.
const findColorByName = (name, colors)=>{
    return colors.find((c)=>c.name.toLowerCase().replace("#", "") === name.replace("#", ""));
};
const findColorByValue = (value, colors)=>{
    return colors.find((c)=>c.id === value);
};
const findCatalogByName = (key, name, filters)=>{
    var _filters_key;
    var _c_name;
    return (_filters_key = filters[key]) === null || _filters_key === void 0 ? void 0 : _filters_key.find((c)=>((_c_name = c.name) !== null && _c_name !== void 0 ? _c_name : c.type).toLowerCase() === name.toLowerCase());
};
const findCatalogByValue = (key, value, filters)=>{
    var _filters_key;
    return (_filters_key = filters[key]) === null || _filters_key === void 0 ? void 0 : _filters_key.find((v)=>v.id === value);
};
/*
 * Retrieve filter query parameters from the URL
 */ const getQueryParams = function() {
    let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for(const key in params){
        const value = params[key];
        switch(key){
            case "minHeight":
            case "maxHeight":
            case "minWidth":
            case "maxWidth":
                filter[key] = value;
                break;
            case "colors":
                if (Array.isArray(value)) {
                    let filteredColors = [];
                    value.forEach((colorName)=>{
                        let color = findColorByName(colorName, filters.colors);
                        if (color) filteredColors.push(color.id);
                    });
                    filter[key] = filteredColors;
                    break;
                }
                let color = findColorByName(value, filters.colors);
                if (color) filter[key] = [
                    color.id
                ];
                break;
            default:
                if (Array.isArray(value)) {
                    let filteredCatalog = [];
                    value.forEach((catalogName)=>{
                        let catalog = findCatalogByName(key, catalogName, filters);
                        if (catalog) filteredCatalog.push(catalog.id);
                    });
                    filter[key] = filteredCatalog;
                    break;
                }
                let catalog = findCatalogByName(key, value, filters);
                if (catalog) filter[key] = [
                    catalog.id
                ];
                break;
        }
    }
    return filter;
};
/*
 * Set filter query parameters in the URL
 */ const setQueryParams = function() {
    let filter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, router = arguments.length > 1 ? arguments[1] : void 0, filters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let params = [];
    for(const key in filter){
        const values = filter[key];
        let paramValues = [];
        if (Array.isArray(values)) {
            values.forEach((value)=>{
                let paramValue = "colors" === key ? findColorByValue(value, filters.colors) : findCatalogByValue(key, value, filters);
                var _paramValue_name;
                if (paramValue) paramValues.push(((_paramValue_name = paramValue.name) !== null && _paramValue_name !== void 0 ? _paramValue_name : paramValue.type).toLowerCase().replace("#", ""));
            });
        } else {
            values && paramValues.push(values);
        }
        if (paramValues.length > 0) {
            params[key] = paramValues;
        }
    }
    if (router.query.id) params.id = router.query.id;
    if (router.query.collection) params.collection = router.query.collection;
    filter && router.push({
        pathname: router.route,
        query: params
    }, undefined, {
        shallow: true
    });
};

;// CONCATENATED MODULE: ./features/actions/useCollectionAction.js









const totalFilters = (search)=>{
    return Object.keys(search).map((key)=>search[key]).filter((val)=>{
        return Array.isArray(val) ? val.length > 0 : !!val;
    }).length;
};
const useCollectionAction = (param)=>{
    let { catalogData , setCatalogData , gallery , filters , collection  } = param;
    const router = (0,next_router.useRouter)();
    const [loading, setLoading] = (0,react.useState)(false);
    const [firstRender, setFirstRender] = (0,react.useState)(true);
    const [showFilters, setShowFilters] = (0,react.useState)(false);
    const [queryFilters, setQueryFilters] = (0,react.useState)(false);
    const _sorts = sorts/* sorts.artworks */.L.artworks;
    const [sort, setSort] = (0,react.useState)("createddesc");
    const [search, setSearch] = (0,react.useState)({
        colors: [],
        collections: [],
        sizes: [],
        type: [],
        orientations: [],
        medium: [],
        material: [],
        minHeight: null,
        maxHeight: null,
        minWidth: null,
        maxWidth: null
    });
    const [collapses, setCollapses] = (0,react.useState)({
        collections: true,
        sizes: true,
        type: true,
        orientations: true,
        medium: true,
        material: true,
        dimensions: true,
        colors: true
    });
    const { setPage , setShouldCall  } = (0,useInfinitePagination/* useInfinitePagination */.J)((page)=>{
        let params = buildParams(search);
        return callArtworksApi({
            ...params,
            page
        }, gallery, collection);
    }, (response)=>setCatalogData({
            ...catalogData,
            data: [
                ...catalogData.data,
                ...response.data
            ]
        }));
    (0,react.useEffect)(()=>{
        if (queryFilters) {
            const params = buildParams(search, sort);
            if (!(0,isEmptyObject/* isEmptyObject */.Q)(params)) {
                setLoading(true);
                callArtworksApi(params, gallery, collection).then((response)=>{
                    setCatalogData(response.data);
                    setLoading(false);
                });
            } else if (!firstRender) {
                callCleanApi();
            }
        }
    }, [
        search,
        sort
    ]);
    (0,react.useEffect)(()=>{
        mapQueryFilters();
        setFirstRender(false);
    }, []);
    const clearFilters = ()=>{
        const initSearch = {
            colors: [],
            collections: [],
            sizes: [],
            shapes: [],
            orientations: [],
            medium: [],
            material: [],
            minHeight: null,
            maxHeight: null,
            minWidth: null,
            maxWidth: null
        };
        setSearch(initSearch);
        setQueryParams(initSearch, router, filters);
    };
    const callCleanApi = ()=>{
        setPage(1);
        setShouldCall(true);
        WindowService/* default.animatedScrollTop */.Z.animatedScrollTop();
        setLoading(true);
        callArtworksApi(null, gallery, collection).then((response)=>{
            setCatalogData(response.data);
            setLoading(false);
        });
    };
    const onClickString = (key, value)=>{
        search[key] = value;
        setSearch({
            ...search
        });
        setQueryParams({
            ...search
        }, router, filters);
    };
    const onClickArray = (key, value)=>{
        const index = search[key].indexOf(value);
        if (index === -1) {
            search[key].push(value);
        } else {
            search[key].splice(index, 1);
        }
        setSearch({
            ...search
        });
        setQueryParams({
            ...search
        }, router, filters);
    };
    const onClickItem = (key, value)=>{
        if ([
            "minHeight",
            "maxHeight",
            "minWidth",
            "maxWidth"
        ].includes(key)) {
            return onClickString(key, value);
        }
        return onClickArray(key, value);
    };
    const mapQueryFilters = ()=>{
        let filterParams = getQueryParams(router.query, {
            ...search
        }, filters);
        setSearch(filterParams);
        setQueryFilters(true);
    };
    const toggleExpand = (key)=>{
        const _collapses = collapses;
        _collapses[key] = !_collapses[key];
        setCollapses({
            ..._collapses
        });
    };
    return {
        loading,
        setLoading,
        search,
        setSearch,
        collapses,
        setCollapses,
        clearFilters,
        onClickItem,
        toggleExpand,
        totalFilters: totalFilters(search),
        showFilters,
        setShowFilters,
        sort,
        setSort,
        sorts: _sorts
    };
};

// EXTERNAL MODULE: ./features/components/GalleryHeader/index.js
var GalleryHeader = __webpack_require__(1115);
// EXTERNAL MODULE: ./features/components/Layout/Container/index.js
var Container = __webpack_require__(1286);
// EXTERNAL MODULE: ./features/components/Layout/HelmetTitle/index.js
var HelmetTitle = __webpack_require__(6470);
// EXTERNAL MODULE: ./features/components/Layout/MobileMenu/index.js
var MobileMenu = __webpack_require__(8127);
// EXTERNAL MODULE: ./features/components/Layout/SearchSortHeader/index.js + 3 modules
var SearchSortHeader = __webpack_require__(8984);
// EXTERNAL MODULE: ./features/components/Layout/Wrapper/index.js
var Wrapper = __webpack_require__(1350);
// EXTERNAL MODULE: ./features/components/LeftSide/index.js + 2 modules
var LeftSide = __webpack_require__(6722);
// EXTERNAL MODULE: ./features/components/Layout/Loader/index.js
var Loader = __webpack_require__(9542);
// EXTERNAL MODULE: ./features/components/Masonry/index.js
var Masonry = __webpack_require__(3827);
// EXTERNAL MODULE: ./features/pages/CollectionPage/ApplyButton.module.scss
var ApplyButton_module = __webpack_require__(4185);
var ApplyButton_module_default = /*#__PURE__*/__webpack_require__.n(ApplyButton_module);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/ApplyButton.js
// TODO: This is the same as the ApplyButton in ArtworksPage, generalize.





const ApplyButton = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return (0,jsx_runtime.jsx)("button", {
        onClick: ()=>{
            onClick();
            WindowService/* default.animatedScrollTop */.Z.animatedScrollTop();
        },
        className: classnames_default()("btn btn-dark", (ApplyButton_module_default())["apply-button"]),
        children: "Apply"
    });
};

// EXTERNAL MODULE: ./features/pages/CollectionPage/FilterButton.module.scss
var FilterButton_module = __webpack_require__(5577);
var FilterButton_module_default = /*#__PURE__*/__webpack_require__.n(FilterButton_module);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FilterList.js
var FilterList = __webpack_require__(5963);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/FilterButton.js
// TODO: This is the same as the FilterButton in ArtworksPage, generalize.





const FilterButton = (param)=>/*#__PURE__*/ {
    let { onClick  } = param;
    return (0,jsx_runtime.jsxs)("button", {
        className: classnames_default()("btn btn-small btn-dark fs-12px mt-3 d-block d-md-none", (FilterButton_module_default())["filter-button"]),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterList/* default */.Z, {
                style: {
                    fontSize: "14px",
                    verticalAlign: "sub",
                    marginRight: "8px"
                }
            }),
            "Filter"
        ]
    });
};

// EXTERNAL MODULE: ./features/pages/CollectionPage/CollectionPage.module.scss
var CollectionPage_module = __webpack_require__(3820);
var CollectionPage_module_default = /*#__PURE__*/__webpack_require__.n(CollectionPage_module);
// EXTERNAL MODULE: ./features/components/Layout/SeoTags/index.js
var SeoTags = __webpack_require__(7182);
// EXTERNAL MODULE: ./features/actions/useContactAction.js
var useContactAction = __webpack_require__(5419);
// EXTERNAL MODULE: ./features/components/GalleryContactModal/index.js
var GalleryContactModal = __webpack_require__(7538);
// EXTERNAL MODULE: ./services/utils/getArtworkSize.js
var getArtworkSize = __webpack_require__(731);
;// CONCATENATED MODULE: ./features/pages/CollectionPage/index.js






















const Collection = (param)=>{
    let { catalog , gallery , filters , collection  } = param;
    var _catalog_collection_label;
    var _catalog_collection_label_label;
    // Use collection label if provided, else re convert to regular and capitalize first letter of each word
    const collectionTitle = (_catalog_collection_label_label = (_catalog_collection_label = catalog.collection_label) === null || _catalog_collection_label === void 0 ? void 0 : _catalog_collection_label.label) !== null && _catalog_collection_label_label !== void 0 ? _catalog_collection_label_label : decodeURIComponent(collection).trim().split(" ").filter((w)=>w.length > 0).map((w)=>w[0].toUpperCase() + w.slice(1)).join(" ");
    const [catalogData, setCatalogData] = (0,react.useState)(catalog);
    const { loading , search , collapses , clearFilters , onClickItem , toggleExpand , totalFilters , showFilters , setShowFilters , sort , setSort , sorts  } = useCollectionAction({
        catalogData,
        setCatalogData,
        gallery,
        filters,
        collection
    });
    const { form , setForm , onSubmit , handleShow , handleClose , modal , success , error , errorMessage , onReCAPTCHAChange , recaptchaRef , loadingContact  } = (0,useContactAction/* useContactAction */.J)(gallery);
    const LoadedElements = ()=>{
        if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {});
        const items = catalogData.data.map((item)=>{
            var _gallery_currency;
            return {
                to: linksBuilder/* linksBuilder.artworks */.m.artworks(item.id, item.title),
                href: "/artworks/[id]",
                title: item.title,
                image: item.image,
                subtitle: item.artistname,
                subSubTitle: (0,getArtworkSize/* getArtworkSize */.Y)(item.width, item.height),
                sold: item.sold,
                price: item.price ? (gallery === null || gallery === void 0 ? void 0 : (_gallery_currency = gallery.currency) === null || _gallery_currency === void 0 ? void 0 : _gallery_currency.symbol) + item.price : null,
                textAlign: "left"
            };
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Masonry/* Masonry */.R, {
            id: "artworks",
            items: items
        });
    };
    const seoURL = "https://discover.artplacer.com/".concat(linksBuilder/* linksBuilder.collections */.m.collections(gallery.domain, collection));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoTags/* SeoTags */.o, {
                title: "Collection | ".concat(collectionTitle, " | Discover ArtPlacer"),
                description: "Discover fine art paintings, posters, prints and photographs from the comfort of your home.",
                url: seoURL,
                canonical: seoURL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HelmetTitle/* HelmetTitle */.i, {
                title: "Collection | ".concat(collectionTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryHeader/* GalleryHeader */.g, {
                            galleryDetails: gallery,
                            onClickContact: handleShow
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "text-capitalize",
                                    style: {
                                        marginTop: "30px",
                                        fontSize: "20px",
                                        whiteSpace: "pre"
                                    },
                                    children: [
                                        "collection: ",
                                        collectionTitle
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            className: "py-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 12,
                                    md: 2,
                                    className: "d-none d-md-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide/* default */.Z, {
                                        search: search,
                                        collapses: collapses,
                                        clearFilters: clearFilters,
                                        onClickItem: onClickItem,
                                        toggleExpand: toggleExpand,
                                        totalFilters: totalFilters,
                                        filters: filters
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    sm: 12,
                                    md: 10,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSortHeader/* SearchSortHeader */.y, {
                                            hideSearch: true,
                                            sort: sort,
                                            setSort: setSort,
                                            sorts: sorts,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton, {
                                                onClick: ()=>setShowFilters(true)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadedElements, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryContactModal/* GalleryContactModal */.X, {
                            form: form,
                            setForm: setForm,
                            galleryDetails: gallery,
                            modal: modal,
                            onSubmit: onSubmit,
                            handleClose: handleClose,
                            error: error,
                            errorMessage: errorMessage,
                            recaptchaRef: recaptchaRef,
                            onReCAPTCHAChange: onReCAPTCHAChange
                        })
                    ]
                })
            }),
            showFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu/* default */.Z, {
                className: (CollectionPage_module_default())["mobile-menu-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((CollectionPage_module_default())["filter-mobile"], "position-relative"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSide/* default */.Z, {
                            search: search,
                            collapses: collapses,
                            clearFilters: clearFilters,
                            onClickItem: onClickItem,
                            toggleExpand: toggleExpand,
                            totalFilters: totalFilters,
                            filters: filters
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplyButton, {
                            onClick: ()=>setShowFilters(false)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var CollectionPage = (Collection);

;// CONCATENATED MODULE: ./pages/galleries/[id]/collections/[collection].js





const Collections = (param)=>{
    let { gallery , catalog , collection , filters , errorCode , errorMessage  } = param;
    if (errorCode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((error_default()), {
            statusCode: errorCode,
            title: errorMessage
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionPage, {
        catalog: catalog,
        gallery: gallery,
        filters: filters,
        collection: collection
    });
};
var __N_SSP = true;
/* harmony default export */ var _collection_ = (Collections);


/***/ }),

/***/ 6656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gallery-header":"GalleryHeader_gallery-header__7ekrE","gallery-header-thumbnail":"GalleryHeader_gallery-header-thumbnail__blmJ4","gallery-header-info":"GalleryHeader_gallery-header-info__5LcNc","gallery-header-bio":"GalleryHeader_gallery-header-bio__RMNZ1","gallery-logo":"GalleryHeader_gallery-logo__g091R","gallery-links":"GalleryHeader_gallery-links__B4b96","gallery-instagram":"GalleryHeader_gallery-instagram__vTlze","gallery-initials":"GalleryHeader_gallery-initials__iGmHS","gallery-inicials":"GalleryHeader_gallery-inicials__K9yw2","contactItemsDesktop":"GalleryHeader_contactItemsDesktop__scyhE","contactItemsMobile":"GalleryHeader_contactItemsMobile__T7TuF"};

/***/ }),

/***/ 7129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading-label":"LoadingLabel_loading-label__Mwpie","loadingBackgroundAnimation":"LoadingLabel_loadingBackgroundAnimation__bAvDv"};

/***/ }),

/***/ 4185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"apply-button":"ApplyButton_apply-button__Gn0_N"};

/***/ }),

/***/ 3820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobile-menu-container":"CollectionPage_mobile-menu-container__azZat","filter-mobile":"CollectionPage_filter-mobile__K0eEQ"};

/***/ }),

/***/ 5577:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filter-button":"FilterButton_filter-button__NgHsr"};

/***/ }),

/***/ 2918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(67)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [662,144,686,501,759,774,888,179], function() { return __webpack_exec__(2231); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);